import { apiWrapper } from 'ccs-ui-components';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { headersInstance } from '../../../../common/utils/HeaderUtils';
import { sagaErrorConst } from '../../../constants';
import { IService, IServiceRequestModel } from '../../../models/index';
import { serviceResponseSchema } from '../../../utilities/sources/RegistriesSchemaDefintion';
import { createService, updateService } from '../../actions/actionType/services/ServiceActionTypes';
import {
  clearUpdateServiceData,
  updateServiceFailure,
  updateServiceStart,
  updateServiceSuccessfull
} from '../../actions/sagaActions/services/UpdateServiceSagaActions';
import { FetchEventFailurePayload } from '../../actions/types/events/FetchEventDetailTypes';
import { UpdateServiceRequest } from '../../actions/types/services/CreateUpdatedServiceTypes';

/**
 * Call create new service API
 * @param serviceName : string
 * @returns api response
 */
export async function callUpdateServiceApi(
  serviceRequestBody: IServiceRequestModel,
  serviceVersion: string
) {
  const resp = await apiWrapper.put<IService, { errorMessage: string }>(
    `${process.env.REACT_APP_API_CONTROL_PLANE_SERVICE_BASE_URL}/services/${serviceRequestBody.serviceName}/version/${serviceVersion}`,
    serviceRequestBody,
    headersInstance()
  );

  const apiResponse = serviceResponseSchema.validate(resp.responseBody, {
    abortEarly: true
  });

  if (resp.isError || !apiResponse.value) {
    return {
      errorMessage: resp.errorBody?.errorMessage,
      isError: resp.isError,
      statusCode: resp.statusCode
    };
  }
  const serviceRecords = resp.responseBody;
  return {
    serviceRecords,
    isError: resp.isError,
    statusCode: resp.statusCode
  };
}

/**
 * Saga to create new service
 * @param requestObject:IServiceRequestModel
 */
export function* updateExistingService({ requestObject, serviceVersion }: UpdateServiceRequest) {
  yield put(clearUpdateServiceData());
  yield put(updateServiceStart());
  try {
    const { serviceRecords } = yield call(callUpdateServiceApi, requestObject, serviceVersion);

    if (serviceRecords) {
      yield put(updateServiceSuccessfull(serviceRecords));
    } else {
      const createEventErrorMessage = sagaErrorConst.createServiceMessage;
      throw new Error(createEventErrorMessage);
    }
  } catch (error) {
    const obj: FetchEventFailurePayload = {
      error: String(error)
    };
    yield put(updateServiceFailure(obj));
  }
}

/**
 * Saga Effect to consider latest request
 */
export function* updateServices() {
  yield takeLatest(updateService.UPDATE_SERVICE, updateExistingService);
}

export function* clearUpdateServiceDetails() {
  yield put(clearUpdateServiceData());
}

export function* clearUpdateServiceDetailsSaga() {
  yield takeLatest(createService.CLEAR_SERVICE_DETAILS, clearUpdateServiceDetails);
}

export const updateServiceSaga = [fork(updateServices)];
